import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import CustomDialog from '../components/custom/CustomDialog';

const AuthExpirationContext = createContext();

export const useAuthExpiration = () => {
    const context = useContext(AuthExpirationContext);
    if (!context) {
        throw new Error('useAuthExpiration must be used within AuthExpirationProvider');
    }
    return context;
};

export const AuthExpirationProvider = ({ children }) => {
    const [open, setOpen] = useState(false);

    const showExpirationDialog = useCallback(() => {
        setOpen(true);
    }, []);

    const hideExpirationDialog = useCallback(() => {
        setOpen(false);
    }, []);

    const handleLogout = useCallback(() => {
        setOpen(false);
        window.location.href = '/logout';
    }, []);

    useEffect(() => {
        if (open) {
            const timer = setTimeout(handleLogout, 10000);
            return () => clearTimeout(timer);
        }
    }, [open, handleLogout]);

    return (
        <AuthExpirationContext.Provider value={{ showExpirationDialog, hideExpirationDialog }}>
            {children}

            <CustomDialog
                open={open}
                title="Session Ended"
                content={
                    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <Typography sx={{ fontSize: '1rem', color: 'text.primary', mb: 2 }}>
                            Your session has been terminated.
                        </Typography>
                        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                            You will be redirected to the home page in 10 seconds.
                            {' '}Click <strong>Log In Again</strong> to continue.
                        </Typography>
                    </Box>
                }
                confirmText="Log In Again"
                onConfirm={handleLogout}
                onCancel={hideExpirationDialog}
                type="warning"
            />

        </AuthExpirationContext.Provider>
    );
};
